import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { TypeSale, typeSaleType } from "../../types/slices/typeSaleType";
import { RootState } from "../store";

const initialState:typeSaleType =
{
    status: ApiStatus.FETCHED,
    typesSale: [],
    typeSaleSelected: {} as TypeSale,
    errorMessage: undefined
}

const typeSaleSlice = createSlice({
    name: 'typesaleSlice',
    initialState,
    reducers: {
        onFetchTypesSale (state, { payload }: { payload: TypeSale[]}) {
            state.status = ApiStatus.FETCHED
            state.typesSale = payload
            state.errorMessage = undefined
        },
        onSetSelectedTypeSale (state, { payload }: { payload: TypeSale }) {
            state.typeSaleSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
    }
})

export const selectTypeSaleState = (state: RootState) => state.typeSaleSlice
export default typeSaleSlice.reducer

export const {
    onFetchTypesSale,
    onSetSelectedTypeSale,
    changeStatus
} = typeSaleSlice.actions